import React from "react";

export default function Checkbox({checked, handleCheckBoxChange}){
    const handleChange = (e)=> {
        handleCheckBoxChange(e)
    }
    return(
        <div>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
        />
        </div>
    )
}